import React from "react";
import MemberTable from "../common/memberTable";
import { NotMessage } from "../../../../common/styled/project";

const MemberList = ({
  isGrp,
  mberList,
  isAllChecked,
  handleCheckAll,
  isChecked,
  handleCheck,
  isSearch,
  participantList,
  handleModalOpen,
  memberName,
  formatPhoneNumber,
  ButtonStateStyle,
  isInvitable,
}) => {
  const cellRenderers = {
    checkbox: (row) => (
      <input type="checkbox" checked={isChecked(row.mberNo)} onChange={() => handleCheck(row)} />
    ),
    cmpnyNm: (row) => row.cmpnyNm,
    mberNm: (row) => memberName(isGrp, row.mberNm),
    moblphonNo: (row) => formatPhoneNumber(row.moblphonNo),
    invite: (row) => {
      const canInvite = isInvitable(row);
      return (
        <button
          style={ButtonStateStyle(canInvite)}
          onClick={() => handleModalOpen([row])}
          disabled={!canInvite}>
          초대
        </button>
      );
    },
  };
  const columns = [
    { label: "", key: "checkbox" },
    ...(!isGrp ? [{ label: "회사명", key: "cmpnyNm" }] : []),
    { label: "이름", key: "mberNm" },
    ...(!isGrp ? [{ label: "휴대번호", key: "moblphonNo" }] : []),
    { label: "초대", key: "invite" },
  ];

  return (
    <div className="section">
      {mberList.length > 0 ? (
        <MemberTable
          isGrp={isGrp}
          columns={columns}
          rows={mberList}
          isAllChecked={isAllChecked}
          onCheckAll={handleCheckAll}
          isChecked={isChecked}
          onCheck={handleCheck}
          renderCell={(row, key) => cellRenderers[key]?.(row) || null}
        />
      ) : (
        <NotMessage>
          {isSearch ? "검색된 멤버가 존재하지 않습니다." : "찾으려는 멤버를 검색해주세요."}
        </NotMessage>
      )}
    </div>
  );
};

export default MemberList;
